var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.646 1.00036H18.316C18.882 0.990352 19.4319 1.1885 19.8614 1.55718C20.291 1.92586 20.5702 2.43942 20.646 3.00036V10.0004C20.5702 10.5613 20.291 11.0749 19.8614 11.4435C19.4319 11.8122 18.882 12.0104 18.316 12.0004H15.646M8.64603 18.0004V18.0004C8.64603 15.7912 6.85517 14.0004 4.64603 14.0004H2.98603C2.69612 14.0036 2.40896 13.9439 2.14445 13.8251C1.87995 13.7064 1.64441 13.5316 1.45417 13.3128C1.26392 13.0941 1.12352 12.8365 1.04269 12.5581C0.961852 12.2797 0.942519 11.987 0.986026 11.7004L2.36603 2.70036C2.43835 2.22346 2.68059 1.78875 3.04812 1.47636C3.41565 1.16396 3.8837 0.994909 4.36603 1.00036H7.64603C12.0643 1.00036 15.646 4.58208 15.646 9.00036V10.3026C15.646 11.422 15.4111 12.5289 14.9565 13.5518L12.6029 18.8473C12.021 20.1566 10.5378 21.1348 9.52471 20.1217V20.1217C8.9621 19.5591 8.64603 18.796 8.64603 18.0004Z",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.ba5a91d6acfe4b888f8097b8922a6f1a.svg";
export { ForwardRef as ReactComponent };